angular.module('callX').controller('RealTimeListCtrl', ['$scope', 'RealTimeService', 'UserService', '$state','ngAudio', function($scope, RealTimeService, UserService, $state, ngAudio) {

    $scope.realTimeData = {};
    $scope.tableContentLoading = false;
    var currentUserData = UserService.getCurrentUserData();
    $scope.searchString = '';

    $scope.maxSize = 3;
    $scope.currentPage = 1;
    $scope.itemsPerPage = 50;

    $scope.pageChanged = function() {
//        console.log("Current Page Num", $scope.currentPage);
    };

    $scope.orderParam = 'created_at';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var setData = function () {
        var campaignsCollection = {};
        if($scope.realTimeData.campaigns){
            $scope.realTimeData.campaigns.forEach(function(campaign) {
                campaignsCollection[campaign.id] = campaign.name;
            });
        }
        var campaignsCollectionType = {};
        if($scope.realTimeData.campaigns){
            $scope.realTimeData.campaigns.forEach(function(campaign){
                campaignsCollectionType[campaign.id] = campaign.type;
            });
        }
        if($scope.realTimeData.calls){
            $scope.realTimeData.calls.forEach(function (call) {
                call.campaign_name = campaignsCollection[call.campaign_id];
                call.campaign_type = campaignsCollectionType[call.campaign_id];
            });
        }
    };

    var fetchRealTimeData = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.realTimeData = data.data;
                $scope.recordingVariable = data.data.publishers[0].recording;
                //console.log($scope.recordingVariable,"these is variable");
                setData();
                $scope.tableContentLoading = false;
                if($state.current.name=='app.real-time.list'){
                    setTimeout(function(){
                        fetchRealTimeData();
                    }, 15000);
                }
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        RealTimeService.getRealTimeData(currentUserData.id, moment().tz(currentUserData.time_zone).format("YYYY-MM-DD HH:mm:ss"), callbacks);
    };

    if(currentUserData.id!=undefined){
        fetchRealTimeData();
    }

    $scope.$on('currentUserUpdate', function(event, userData) {
        currentUserData = userData;
        fetchRealTimeData();
    });

    $scope.playCallRecording = function (url) {
        if($scope.sound!=undefined){
            $scope.sound.stop();
        }
        $scope.sound = ngAudio.load(url);
        $scope.sound.play();
    };

    $scope.pauseCallRecording = function(){
        $scope.sound.pause();
    };

    $scope.resumeCallRecording = function(){
        $scope.sound.play();
    };

}]);